module.exports = __webpack_public_path__ + "static/logo-ue1-15aecc9c59f40460279518dbafe960be.svg";